import { render, staticRenderFns } from "./GallerySticky.vue?vue&type=template&id=27762b36&"
import script from "./GallerySticky.vue?vue&type=script&lang=js&"
export * from "./GallerySticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27762b36')) {
      api.createRecord('27762b36', component.options)
    } else {
      api.reload('27762b36', component.options)
    }
    module.hot.accept("./GallerySticky.vue?vue&type=template&id=27762b36&", function () {
      api.rerender('27762b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/gallery/GallerySticky.vue"
export default component.exports